<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_437_7770)">
            <path d="M17.5234 19.9034C17.2474 18.0546 19.5 15.5 19.5 15.5C19.5 15.5 21.7525 18.0546 21.4765 19.9034C21.2534 21.398 20.0516 21.5 19.5 21.5C18.9484 21.5 17.7466 21.398 17.5234 19.9034Z" stroke="currentColor"/>
            <path d="M7.42516 2.39667L17.9557 8.50463C18.5321 8.83896 18.5763 9.65478 18.0394 10.0494V10.0494L16.2145 11.3905C16.1013 11.4736 16.007 11.5796 15.9376 11.7016L11.4244 19.6309C11.1512 20.1109 10.5406 20.2786 10.0606 20.0054L1.36896 15.0583C0.889026 14.7851 0.721366 14.1746 0.994461 13.6947L1.74324 12.3787L5.44553 5.87177M7.42516 2.39667L4.81754 0.912307C4.33757 0.63909 3.727 0.806691 3.45378 1.28665L2.46446 3.02457C2.19121 3.50458 2.35887 4.11522 2.83892 4.38841L5.44553 5.87177M7.42516 2.39667L5.44553 5.87177" stroke="currentColor" stroke-linejoin="round"/>
            <path d="M4.21788 10.9937C4.39664 10.6841 4.72711 10.4935 5.08463 10.4937L13.2782 10.4997C14.0457 10.5003 14.5265 11.3296 14.1456 11.996L10.8825 17.7041C10.6076 18.185 9.99408 18.3508 9.51434 18.0738L3.34225 14.5104C2.86396 14.2342 2.70008 13.6226 2.97622 13.1444L4.21788 10.9937Z" :fill="color"/>
            <circle cx="21" cy="1" r="0.5" fill="currentColor" stroke="currentColor"/>
            <circle cx="17" cy="1" r="0.5" fill="currentColor" stroke="currentColor"/>
        </g>
        <defs>
            <clipPath id="clip0_437_7770">
                <rect width="22" height="22" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'SVGColor2',
    props: [
        'color',
    ],
};
</script>

<style scoped lang="scss">

</style>
